import { useQuery } from '@tanstack/react-query';
import { axiosAPI } from './axios-instance';
import { ApiResponse, Product } from '@/types';

export type ApiCompareOrViewedRequest = Partial<{
    ids: number[];
    limit?: number;
}>;

export type ApiCompareOrViewedResponse = ApiResponse<{
    items: Product[];
}>;

export const getCompareOrViewed = ({
    params,
    signal,
}: { params?: ApiCompareOrViewedRequest; signal?: AbortSignal } = {}) =>
    axiosAPI.get<ApiCompareOrViewedResponse>(`/v5/products/compare`, { params, signal }).then((res) => res.data);

export const useCompareOrViewedQuery = ({
    queryParams,
    initialData,
    callback,
    enabled,
}: {
    queryParams?: ApiCompareOrViewedRequest;
    initialData?: ApiCompareOrViewedResponse;
    callback?: () => void;
    enabled?: boolean;
} = {}) =>
    useQuery({
        queryKey: ['compare', queryParams],
        queryFn: ({ signal }) => getCompareOrViewed({ params: queryParams, signal }),
        keepPreviousData: true,
        initialData,
        placeholderData: initialData,
        onSettled: () => {
            callback?.();
        },
        enabled,
    });
